import { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { SafariView, BrowserDetector } from 'react-browser-detector';

export const useSupports = (supportCondition) => {
    // Create a state to store declaration check result
    const [checkResult, setCheckResult] = useState(false);

    useEffect(() => {
        // Run check as a side effect, on user side only
        setCheckResult(CSS.supports(supportCondition));
    }, [supportCondition]);


    return checkResult;
};


function DonneesPersonnelle({
    interaction,
    setField,
    userInformation,
    donneesPersonnelleValid,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    saveDonneePersonnelle,
}) {

    const isSafari = useSupports("-webkit-hyphens:none");
    return (
        <div className="custom-gather-informations">
            {interaction.segment_customisation.text_personal &&
                <Row className="text-personal">
                    <Col>{interaction.segment_customisation.text_personal}
                    </Col>
                </Row>
            }
            {interaction.information_to_gather.first_name?.active &&
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label></Form.Label>
                            <Form.Control name="first_name"
                                autocomplete="given-name"
                                onChange={setField}
                                type="text"
                                isInvalid={!donneesPersonnelleValid['first_name']}
                                defaultValue={userInformation['first_name']}
                                placeholder={'Prénom' + (interaction.information_to_gather.first_name.mandatory ? ' (obligatoire)' : '')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }
            {interaction.information_to_gather.name?.active &&
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label></Form.Label>
                            <Form.Control name="name"
                                autocomplete="family-name"
                                onChange={setField}
                                isInvalid={!donneesPersonnelleValid["name"]}
                                defaultValue={userInformation['name']}
                                placeholder={'Nom' + (interaction.information_to_gather.name.mandatory ? ' (obligatoire)' : '')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }
            {interaction.information_to_gather.age?.active &&
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label></Form.Label>
                            <Form.Control name="age"
                                onChange={setField}
                                required={interaction.information_to_gather.age.mandatory}
                                isInvalid={!donneesPersonnelleValid["age"]}
                                defaultValue={userInformation['age']}
                                placeholder={'Age' + (interaction.information_to_gather.age.mandatory ? ' (obligatoire)' : '')}
                            //Todo Activer les masks
                            // mask="99"
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }
            {interaction.information_to_gather.city?.active &&
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label></Form.Label>
                            <Form.Control name="city"
                                onChange={setField}
                                required={interaction.information_to_gather.city.mandatory}
                                isInvalid={!donneesPersonnelleValid["city"]}
                                defaultValue={userInformation['city']}
                                placeholder={'Ville' + (interaction.information_to_gather.city.mandatory ? ' (obligatoire)' : '')}
                            />
                        </Form.Group>
                    </Col>
                </Row >
            }
            {interaction.information_to_gather.phone?.active &&
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label></Form.Label>
                            <Form.Control name="phone"
                                onChange={setField}
                                required={interaction.information_to_gather.phone.mandatory}
                                isInvalid={!donneesPersonnelleValid["phone"]}
                                defaultValue={userInformation['phone']}
                                placeholder={'Téléphone' + (interaction.information_to_gather.phone.mandatory ? ' (obligatoire)' : '')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }
            {interaction.information_to_gather.email?.active &&
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label></Form.Label>
                            <Form.Control name="email"
                                autocomplete="email"
                                onChange={setField}
                                required={interaction.information_to_gather.email.mandatory}
                                isInvalid={!donneesPersonnelleValid["email"]}
                                defaultValue={userInformation['email']}
                                placeholder={'Email' + (interaction.information_to_gather.email.mandatory ? ' (obligatoire)' : '')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }
            <Row className="custom-remember-me">
                <Col className='col-9'>
                    <Form.Label htmlFor="rememberMe">Mémoriser mes informations</Form.Label>
                    {rememberMe && isSafari &&
                        <SafariView>
                            <p class="text-normal">
                                Safari ne prend pas en charge la mémorisation de vos informations, utilisez l’auto-remplissage iOS pour vos prochains messages.
                            </p>
                        </SafariView>
                    }
                </Col>
                <Col className="text-end">
                    <Form.Check
                        type="switch"
                        name="rememberMe"
                        inline="true"
                        checked={rememberMe}
                        onChange={handleRememberMeChange}
                    />
                </Col>
            </Row>
            <Row className="custom-commandes">
                <Col>
                    <Button onClick={saveDonneePersonnelle}>Continuer</Button>
                </Col>
            </Row>

        </div>
    );
}

export default DonneesPersonnelle;